angular.module('contabilidad.reportenominasmovimientos')
  .service('ContabilidadReportenominasmovimientos', ContabilidadReportenominasmovimientosService)

var ContabilidadReportenominasmovimientosSchema = {
  total: 'number',
}

function ContabilidadReportenominasmovimientosService ($http) {
  this.get = get

  function get (data) {
    return $http.post('/api/nominas/reportes/movimientos', data, {
      schema: ContabilidadReportenominasmovimientosSchema,
      headers: {
        'X-HTTP-Method-Override': 'GET',
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/reportenominasmovimientos/services/Reportenominasmovimientos.js